import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './ppa/shared/components/header/header.component';
import { BannerComponent } from "./ppa/shared/components/banner/banner.component";
import { FooterComponent } from './shared/components/footer/footer.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, BannerComponent, FooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'portal-plano-orcamentario';

  constructor(public router: Router) {}

  isPpaRoute(): boolean {
    return this.router.url.startsWith('/ppa');
  }
}
